import PropTypes from 'prop-types'
import { H4, Caption } from '../../../cdl-react-components/components'
import Link from '../../../Utilities/Link'
import { formatResultsItemDate } from '../../../../utilities'

const activityMapItem = (props) => {    
    const { activityMap } = props
    return (
        <Link
            href={'/activityMap/' + activityMap.id}
            onClick={props.handleResultSelect}
            className={'results__item' + (new Date(activityMap.publication_date) > Date.now() ? ' unpublished': '')}
            title={activityMap.title}>
            <H4>{activityMap.title}</H4>
            <Caption>Activity Map | {formatResultsItemDate(activityMap)}</Caption>
        </Link>
    )
}

activityMapItem.propTypes = {
    activityMap: PropTypes.object.isRequired,
    handleResultSelect: PropTypes.func.isRequired
}

export default activityMapItem